import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const API_BASE = process.env.REACT_APP_API_URL || "";

function buildUrl(path) {
  return `${API_BASE.replace(/\/$/, "")}${path}`;
}

const FALLBACK_TESTIMONIALS = [
  {
    name: "Maria Doe",
    designation: "Traveller",
    image: "/assets/img/testimonial/testi_1_1.jpg",
    text: "A home that perfectly blends sustainability with luxury until I discovered Ecoland Residence. From the moment I stepped into this community, I knew it was where I wanted to live. The commitment to eco-friendly living.",
  },
  {
    name: "Andrew Simon",
    designation: "Traveller",
    image: "/assets/img/testimonial/testi_1_2.jpg",
    text: "The home boasts sleek, contemporary architecture with clean lines and expansive windows, allowing natural light to flood the interiors. It incorporates passive design principles.",
  },
  {
    name: "Alex Jordan",
    designation: "Traveller",
    image: "/assets/img/testimonial/testi_1_1.jpg",
    text: "Solar panels adorn the roof, harnessing renewable energy to power the home and even feed excess electricity back into the grid. High-performance insulation and triple-glazed windows enhance energy efficiency.",
  },
  {
    name: "Maria Doe",
    designation: "Traveller",
    image: "/assets/img/testimonial/testi_1_1.jpg",
    text: "A home that perfectly blends sustainability with luxury until I discovered Ecoland Residence. From the moment I stepped into this community, I knew it was where I wanted to live. The commitment to eco-friendly living.",
  },
  {
    name: "Andrew Simon",
    designation: "Traveller",
    image: "/assets/img/testimonial/testi_1_2.jpg",
    text: "The home boasts sleek, contemporary architecture with clean lines and expansive windows, allowing natural light to flood the interiors. It incorporates passive design principles.",
  },
  {
    name: "Alex Jordan",
    designation: "Traveller",
    image: "/assets/img/testimonial/testi_1_1.jpg",
    text: "Solar panels adorn the roof, harnessing renewable energy to power the home and even feed excess electricity back into the grid. High-performance insulation and triple-glazed windows enhance energy efficiency.",
  },
];

function TestimonialOne() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetch(buildUrl("/api/reviews"))
      .then((res) => res.json())
      .then((data) => {
        if (!cancelled && data.success && Array.isArray(data.reviews)) {
          setReviews(data.reviews);
        }
      })
      .catch(() => {
        if (!cancelled) setReviews([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) return null;
  if (!loading && reviews.length === 0) return null;

  const items = reviews.map((rev, index) => {
    const fallback = FALLBACK_TESTIMONIALS[index % FALLBACK_TESTIMONIALS.length];
    return {
      name: rev.name || fallback.name,
      designation: "Traveller",
      image: fallback.image,
      text: rev.description || fallback.text,
      rating: rev.rating || 5,
    };
  });

  return (
    <section className="testi-area overflow-hidden space shape-mockup-wrap" id="testi-sec">
      <div className="container-fluid p-0">
        <div className="title-area mb-20 text-center">
          <span className="sub-title">Testimonial</span>
          <h2 className="sec-title">What Clients Say About Us</h2>
        </div>
        <div className="slider-area">
          <Swiper
            modules={[Pagination, Navigation, Autoplay]}
            pagination={{ clickable: true }}
            spaceBetween={30}
            centeredSlides={true}
            loop={true}
            slidesPerGroup={1}
            speed={1200}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              0: { slidesPerView: 1},
              767: { slidesPerView: 2},
              992: { slidesPerView: 2},
              1200: { slidesPerView: 2},
              1400: { slidesPerView: 3},
            }}
            className="testiSlider1 has-shadow"
          >
            {items.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="testi-card">
                  <div className="testi-card_wrapper">
                    <div className="testi-card_profile">
                      <div className="media-body">
                        <h3 className="box-title">{item.name}</h3>
                        <span className="testi-card_desig">{item.designation}</span>
                      </div>
                    </div>
                    <div className="testi-card_review">
                      {[1, 2, 3, 4, 5].map((i) => (
                        <i
                          key={i}
                          className={`${i <= (item.rating || 5) ? "fa-solid" : "fa-regular"} fa-star`}
                        />
                      ))}
                    </div>
                  </div>
                  <p className="testi-card_text">{item.text}</p>
                  <div className="testi-card-quote">
                    <img src="/assets/img/icon/testi-quote.svg" alt="img" />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="slider-pagination" />
        </div>
      </div>
    </section>
  );
}

export default TestimonialOne;
